import { debounce } from 'lodash'
import { useMemo, useEffect, useState } from 'react'

import type { RouteApiWithSearch } from '../types/route-api-with-search'

type PaginationAndSearch = {
  search?: string
  page: number
  pageSize: number
}

export const useDebounceSearch = (
  routeApi: RouteApiWithSearch<PaginationAndSearch>
) => {
  const navigate = routeApi.useNavigate()
  const { search } = routeApi.useSearch()

  const [searchValue, setSearchValue] = useState(search)

  const debouncedSearch = useMemo(
    () =>
      debounce(val => {
        navigate({
          search: previousValue => ({
            ...previousValue,
            page: 1,
            search: val
          })
        })
      }, 500),
    [navigate]
  )

  useEffect(() => {
    setSearchValue(search || '')
  }, [search])

  const handleChangeSearch = (val: string) => {
    setSearchValue(val)
    debouncedSearch(val)
  }
  return {
    searchValue,
    handleChangeSearch
  }
}
